import styled from 'styled-components';

export const SettingsButton = styled.button`
    background: transparent;
    border: none;
    color: #fff;
    cursor: pointer;
    padding: 8px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    font-size: 14px;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;

export const SettingsSidebar = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    width: 320px;
    height: 100vh;
    background: #282E33;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    display: flex;
    flex-direction: column;
`;

export const SidebarHeader = styled.div`
    padding: 14px 20px;
    border-bottom: 1px solid #3B444C;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #22272B;
`;

export const HeaderTitle = styled.h3`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #B6C2CF;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #B6C2CF;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    width: 32px;
    height: 32px;
    
    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }

    svg {
        stroke: currentColor;
    }
`;

export const SidebarContent = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    background: #282E33;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #22272B;
    }

    &::-webkit-scrollbar-thumb {
        background: #3B444C;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #465059;
    }
`;

export const MenuItem = styled.button`
    width: 100%;
    text-align: left;
    padding: 8px 20px;
    background: none;
    border: none;
    cursor: pointer;
    color: #B6C2CF;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 3px;

    &:hover {
        background: #3B444C;
    }

    span {
        color: #8C9BAB;
    }
`;

export const BackgroundPickerContainer = styled.div`
    padding: 20px;
    background: #282E33;
`;

export const UserMenuButton = styled.button`
    background: transparent;
    border: none;
    color: #fff;
    cursor: pointer;
    padding: 8px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    font-size: 14px;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;

export const UserMenuDropdown = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    background: #282E33;
    border-radius: 3px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    min-width: 200px;
`;

export const UserMenuItem = styled.button`
    width: 100%;
    text-align: left;
    padding: 8px 20px;
    background: none;
    border: none;
    cursor: pointer;
    color: #B6C2CF;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 3px;

    &:hover {
        background: #3B444C;
    }
`;
